import { createAsyncThunk } from '@reduxjs/toolkit';
import QueryString from 'qs';
import { cloneDeep } from 'lodash-es';
import ApiaApi, { makeApiaUrl } from '../../../../../api/apiaApi/apiaApi';
import store, { TRootState } from '../../../..';
import {
  TApiaFilter,
  TApiaFilterValue,
  TApiaFunction,
  TApiaLoad,
} from '../../../../../types';
import { TResponsiveTableRow } from '../../../../../components/common/generic/responsiveTable/types';
import { parseRows } from '../../util/rowsParser';
import { buttonsActions } from '../../../../buttonsSlice';
import { TListRowsStructure } from '../../../types';
import { listActions } from '../../..';
import notifyRequiredFilters from '../../util/notifyRequiredFilters';
import { notify } from '../../../../../components/common/notifications/util';
import {
  TApiaFunctionPageInfo,
  TApiaRowDefinition,
  arrayOrArray,
} from '@apia/util';

export type TTableRows = {
  rows: TResponsiveTableRow[];
};

const filterEntities = createAsyncThunk<
  TListRowsStructure & {
    filters?: TApiaFilter[] | undefined;
    customLabel?: string;
  },
  {
    listId: string;
    filters?: TApiaFilter[];
    filtersDeleted?: boolean;
    forceAjaxUrl?: boolean;
    forceTabId?: boolean;
  },
  { state: TRootState }
>(
  'listSlice/filterEntities',
  async (
    {
      forceAjaxUrl = false,
      forceTabId = false,
      listId,
      filters,
      // filtersDeleted,
    },
    thunkApi,
  ) => {
    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: true,
          action: 'disableTable',
        },
      ]),
    );

    const state = thunkApi.getState().listSlice.lists[listId];
    const { dispatch } = thunkApi;

    // Helper function to check if a value is empty (undefined or empty string)
    const isEmpty = (value: any) => value === undefined || value === '';
    /**
     * La siguiente logica se encarga de detecctar si todos los filtros
     * requeridos fueron ingresados. De ser asi o si no hay filtros requeridos,
     * isRequirementSet deberia cambiar a true
     */
    let isRequirementSet = false;
    let required = 0;
    let withValue = 0;

    if (filters) {
      state.filters?.forEach((innerFilter) => {
        if (
          !filters.find(
            (incommingfilter) => incommingfilter.id === innerFilter.id,
          )
        ) {
          if (innerFilter.required) {
            required++;
            if (['date', 'D'].includes(innerFilter.type as string)) {
              if (
                innerFilter.dateFromRequired &&
                !isEmpty(innerFilter.currentValue)
              ) {
                withValue++;
              } else if (
                innerFilter.dateRequired &&
                !isEmpty(innerFilter.currentValue) &&
                !isEmpty(innerFilter.filterToValue)
              ) {
                withValue++;
              } else if (
                innerFilter.dateToRequired &&
                !isEmpty(innerFilter.filterToValue)
              ) {
                withValue++;
              }
            } else if (innerFilter.currentValue) {
              withValue++;
            }
          }
        }
      });
      filters.forEach((innerFilter) => {
        if (innerFilter.required) {
          required++;
          if (['date', 'D'].includes(innerFilter.type as string)) {
            if (
              innerFilter.dateFromRequired &&
              !isEmpty(innerFilter.currentValue)
            ) {
              withValue++;
            } else if (
              innerFilter.dateRequired &&
              !isEmpty(innerFilter.currentValue) &&
              !isEmpty(innerFilter.filterToValue)
            ) {
              withValue++;
            } else if (
              innerFilter.dateToRequired &&
              !isEmpty(innerFilter.filterToValue)
            ) {
              withValue++;
            }
          } else if (innerFilter.currentValue) {
            withValue++;
          }
        }
      });
    }

    if (required === withValue) isRequirementSet = true;

    /**
     * La siguiente logica se encarga de guardar en newFilters cada filtro en
     * el estado con los cambios de valor realizados
     */

    const newFilters = filters
      ? (state.filters?.map((currentFilter) => {
          let updatingFilter: TApiaFilter | undefined = cloneDeep(
            filters.find((searchFilter) => {
              if (
                ['date', 'D'].includes(searchFilter.type ?? '') &&
                ['date', 'D'].includes(currentFilter.type ?? '')
              ) {
                if (searchFilter.id === currentFilter.filterToId) {
                  return searchFilter.id === currentFilter.filterToId;
                }
                return searchFilter.id === currentFilter.id;
              }

              return searchFilter.id === currentFilter.id;
            }),
          );

          if (updatingFilter) {
            if (
              ['date', 'D'].includes(currentFilter.type ?? '') &&
              updatingFilter.id === currentFilter.filterToId
            ) {
              updatingFilter.id = currentFilter.id;
              updatingFilter.filterToValue = updatingFilter.currentValue;
              updatingFilter.currentValue = currentFilter.currentValue;
              updatingFilter = {
                ...currentFilter,
                currentValue: updatingFilter.currentValue,
                filterToValue: updatingFilter.filterToValue,
                deleteFiltersTimestamp: updatingFilter.deleteFiltersTimestamp,
                changeFiltersTimestamp: updatingFilter.changeFiltersTimestamp,
                errorFrom:
                  !!updatingFilter.currentValue &&
                  currentFilter.errorFrom === 'Filtro requerido' &&
                  updatingFilter.errorFrom === undefined
                    ? undefined
                    : updatingFilter.errorFrom
                      ? updatingFilter.errorFrom
                      : !updatingFilter.currentValue &&
                          currentFilter.errorFrom === 'Filtro requerido'
                        ? currentFilter.errorFrom
                        : undefined,
                errorTo:
                  !!updatingFilter.filterToValue &&
                  currentFilter.errorTo === 'Filtro requerido' &&
                  updatingFilter.errorTo === undefined
                    ? undefined
                    : updatingFilter.errorTo
                      ? updatingFilter.errorTo
                      : !updatingFilter.filterToValue &&
                          currentFilter.errorTo === 'Filtro requerido'
                        ? currentFilter.errorTo
                        : undefined,
                error:
                  !!updatingFilter.filterToValue &&
                  !!updatingFilter.currentValue &&
                  currentFilter.error === 'Filtro requerido' &&
                  updatingFilter.error === undefined
                    ? undefined
                    : updatingFilter.error
                      ? updatingFilter.error
                      : !(
                            !!updatingFilter.filterToValue &&
                            !!updatingFilter.currentValue
                          ) && currentFilter.error === 'Filtro requerido'
                        ? currentFilter.error
                        : undefined,
              };
            } else if (
              updatingFilter.options &&
              !(
                [
                  'processesAdHocControl',
                  'processesAdHocControl',
                  'processFinalizeControl',
                  'processPriorityControl',
                  'processReasignControl',
                  'processesRollbackControl',
                  'processChangeDateControl',
                ].includes(window.listData[listId].component) &&
                updatingFilter.id === 'cmbSta'
              )
            ) {
              updatingFilter.options = updatingFilter.options.map((option) => {
                if (updatingFilter?.currentValue === option.value) {
                  return {
                    ...option,
                    selected: true,
                  };
                }
                return {
                  ...option,
                  selected: false,
                };
              });

              updatingFilter.error =
                !!updatingFilter.currentValue &&
                currentFilter.error === 'Filtro requerido'
                  ? undefined
                  : currentFilter.error;
            }

            return { ...currentFilter, ...updatingFilter };
          }

          return currentFilter;
        }) ?? [])
      : (state.filters ?? []);

    /**
     * La siguiente logica se encarga de armar el payload que se enviara para
     * settear los filtros en el bean
     */

    const payloadFilters: Record<string, unknown> = {
      filter: true,
      back: false,
    };

    newFilters?.forEach((currentFilter) => {
      payloadFilters[`${currentFilter.id}`] = currentFilter.currentValue;
      if (currentFilter.options) {
        currentFilter.options.forEach((option) => {
          if (option.selected) {
            payloadFilters[`${currentFilter.id}`] = option.value;
          }
        });
      }
      if (['date', 'D'].includes(currentFilter.type as string)) {
        payloadFilters[`${currentFilter.filterToId as string}`] =
          currentFilter.filterToValue;
      }
    });

    if (isRequirementSet) {
      const result = await ApiaApi.post<
        TApiaLoad<
          TApiaFunction<{
            result:
              | {
                  pageInfo: TApiaFunctionPageInfo;
                  table?: {
                    row: TApiaRowDefinition | TApiaRowDefinition[];
                  };
                }
              | {
                  pageInfo: TApiaFunctionPageInfo;
                  table?: {
                    row: TApiaRowDefinition | TApiaRowDefinition[];
                  };
                }[];
          }>
        >
      >(
        makeApiaUrl({
          action: 'filter',
          preventAsXmlParameter: true,
          isAjax: true,
          timestamp: Date.now(),
          react: true,
          ajaxUrl: forceAjaxUrl ? state.ajaxUrl : undefined,
          tabId: forceTabId ? state.tabId : undefined,
        }),
        {
          postData: QueryString.stringify(payloadFilters),
        },
      );
      store.dispatch(
        buttonsActions.updateAction([
          {
            performing: false,
            action: 'disableTable',
          },
        ]),
      );
      if (result && result.data) {
        const additionalFilters: TApiaFilter[] = arrayOrArray(
          arrayOrArray(result.data.function.messages.result)[1].table?.row,
        )
          .map((row, i, arr) => {
            const returnFilter: TApiaFilter = {
              currentValue: arrayOrArray(row.cell)[3] as TApiaFilterValue,
              type: arrayOrArray(row.cell)[2] as
                | 'date'
                | 'D'
                | 'S'
                | 'number'
                | 'N'
                | 'apiaNumber'
                | 'triple'
                | 'dateHour',
              id: arrayOrArray(row.cell)[1] as string,
              title: arrayOrArray(row.cell)[0] as string,
              placeholder: arrayOrArray(row.cell)[0] as string,
              toolTip: arrayOrArray(row.cell)[0] as string,
              filterToId: ['date', 'D'].includes(
                arrayOrArray(row.cell)[2] as string,
              )
                ? `${arrayOrArray(row.cell)[1] as string}To`
                : undefined,
              filterToValue: ['date', 'D'].includes(
                arrayOrArray(row.cell)[2] as string,
              )
                ? ``
                : undefined,
              group: 'entitySpecific',
              asAdditional: true,
              deleteFiltersTimestamp: Date.now(),
            };
            const currentId = [...(arrayOrArray(row.cell)[1] as string)];
            const nextId = arr[i + 1]
              ? [...(arrayOrArray(arr[i + 1].cell)[1] as string)]
              : '';
            const prevId = arr[i - 1]
              ? [...(arrayOrArray(arr[i - 1].cell)[1] as string)]
              : '';
            if (
              ['D', 'date'].includes(returnFilter.type as string) &&
              arr[i + 1] &&
              currentId.every((char, i, innerArr) => {
                if (!innerArr[i + 1]) {
                  return true;
                }
                return char === nextId[i];
              })
            ) {
              returnFilter.filterToId = arrayOrArray(
                arr[i + 1].cell,
              )[1] as string;
            } else if (
              ['D', 'date'].includes(returnFilter.type as string) &&
              arr[i - 1] &&
              currentId.every((char, i, innerArr) => {
                if (!innerArr[i + 1]) {
                  return true;
                }
                return char === prevId[i];
              })
            ) {
              return undefined;
            }

            return returnFilter;
          })
          .filter((e): e is TApiaFilter => e !== undefined);
        const hasChangedType =
          state.filters?.find((f) => f.id === 'busEntId')?.currentValue !==
          payloadFilters['busEntId'];
        return {
          rows: parseRows(
            listId,
            arrayOrArray(
              arrayOrArray(result.data.function.messages.result)[0].table?.row,
            ),
          ),
          filters: [
            ...(!hasChangedType &&
            newFilters.some((f) => {
              return additionalFilters.find((af) => af.id === f.id);
            })
              ? newFilters
              : [
                  ...(newFilters
                    ? newFilters.filter(
                        (filter) => filter.group !== 'entitySpecific',
                      )
                    : []),
                  ...additionalFilters,
                ]),
          ],
          pageInfo: arrayOrArray(result.data.function.messages.result)[0]
            .pageInfo,
          customLabel: window.FINDER_NO_DATA,
        };
      }
    } else {
      store.dispatch(
        buttonsActions.updateAction([
          {
            performing: false,
            action: 'disableTable',
          },
        ]),
      );
      notify({
        message: `${window.MSG_FILTER_REQUIRED}`,
        type: 'warning',
      });
      void dispatch(
        listActions.setState({
          listId,
          rows: [],
          filters: notifyRequiredFilters(listId, newFilters),
          customLabel: window.MSG_FILTER_REQUIRED,
        }),
      );
      return {
        rows: [],
        filters: notifyRequiredFilters(listId, newFilters),
        customLabel: window.MSG_FILTER_REQUIRED,
      };
    }

    throw new Error();
  },
);

export default filterEntities;
